module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_error_large-cc74df66c86b3d77c248523b7a6d17c9.png";